import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
  TemplateRef,
  viewChild,
} from '@angular/core';
import {
  CalendarDatePipe,
  CalendarEvent,
  CalendarView,
} from 'angular-calendar';
import { TranslocoPipe } from '@jsverse/transloco';
import { CalendarHelper } from './../../../../../core/common/helpers/calendar/calendar.helper';
import { BusinessCalendarEvent } from './../../../../../core/common/models/calendar.model';
import { CalendarEventModalComponent } from './../../../../../core/common/components/calendar-event-modal/calendar-event-modal.component';
import { CALENDAR_EVENT_COLOR } from '../../../../../core/common/constants/calendar-event-color';

@Component({
  selector: 'lib-month-cell-template',
  imports: [CalendarDatePipe, TranslocoPipe, CalendarEventModalComponent],
  templateUrl: './month-cell-template.component.html',
  styleUrl: './month-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class MonthCellTemplateComponent {
  readonly CalendarView = CalendarView;
  readonly CALENDAR_EVENT_COLOR = CALENDAR_EVENT_COLOR;

  readonly calendarHelper = inject(CalendarHelper);

  readonly customMonthCellTemplate = viewChild.required<TemplateRef<unknown>>(
    'customMonthCellTemplate'
  );

  viewDate = input.required<Date>();
  eventActionsTemplate = input<TemplateRef<unknown> | null>(null);
  setView = output<CalendarView>();
  eventClick = output<CalendarEvent>();
  viewDateChange = output<Date>();

  selectedEvent = computed<BusinessCalendarEvent | null>(() => {
    return this.calendarHelper.selectedEvent();
  });

  closeEventDetails() {
    this.calendarHelper.clearSelectedEvent();
  }

  isSelectedOccurrence(event: CalendarEvent): boolean {
    return this.calendarHelper.isSelectedOccurrence(event);
  }

  onViewDateChange(date: Date): void {
    this.viewDateChange.emit(new Date(date));
  }
}
